// Self-Signup and Plan Purchase Analytics Events
export const PLAN_SELECTOR_CHANGED = 'plan_selector_changed';
export const CHECKOUT_BUTTON_CLICKED = 'checkout_button_clicked';
export const NAVIGATED_TO_STRIPE_CHECKOUT_PAGE =
  'navigated_to_stripe_checkout_page';
export const PRICING_CARD_ESSENTIAL_SELECTED =
  'pricing_card_essential_selected';
export const PRICING_CARD_PROFESSIONAL_SELECTED =
  'pricing_card_professional_selected';
export const SIGNUP_CONFIRMATION_LOGIN_BUTTON_CLICKED =
  'signup_confirmation_login_button_clicked';
export const START_FREE_TRIAL_BUTTON_CLICKED =
  'start_free_trial_button_clicked';
export const SIGNUP_SUCCESSFULL = 'signup_successfull';
export const SIGNUP_BUTTON_CLICKED = 'signup_button_clicked';
export const SIGNUP_PAGE_VIEWED = 'signup_page_viewed';
export const SIGNUP_CONTINUE_CLICKED = 'signup_continue_clicked';
export const SIGNUP_VERIFICATION_EMAIL_SENT = 'signup_verification_email_sent';
export const SIGNUP_EMAIL_VERIFIED = 'signup_email_verified';
// eslint-disable-next-line
export const SIGNUP_PASSWORD_SET = 'clicked_set_signup_password';
export const TENANT_CREATED = 'tenant_created';
export const CONFIRMATION_MODULE_VIEWED = 'confirmation_module_viewed';
export const ONBOARDING_STARTED = 'onboarding_started';
export const SIGNUP_RESEND_VERIFICATION_EMAIL_SENT =
  'signup_resend_verification_email_clicked';
export const SIGNUP_RESEND_EMAIL_SENT_SUCCESSFULL =
  'signup_resend_verification_email_click_successful';
export const SIGNUP_RESEND_EMAIL_FAILED =
  'signup_resend_verification_email_click_failed';
export const SERVER_NOT_REACHABLE = 'signup_continue_server_not_reachable';
export const COPIED_TENANT_LINK = 'copied_tenant_link';

// Chat Analytics Events
export const PAGE_VIEWED_EVENT = '$pageview';
export const CHAT_BUTTON_CLICKED = 'chat_button_clicked';
export const CHAT_TOOLS_SELECTED = 'chat_tools_selected';
export const CHAT_TOOL_EXECUTED = 'chat_tool_executed';
export const CHAT_QUERY_SUBMITTED = 'chat_query_submitted';
export const CHAT_QUERY_COMPLETED = 'chat_query_completed';
export const CHAT_CREDIT_LIMIT_EXCEEDED = 'chat_credit_limit_exceeded';
export const CHAT_ERROR_OCCURRED = 'chat_error_occurred';

export const E_ASSISTANT_CARD = 'assistant_card';
export const E_DATA_LIBRARY = 'data_library';
export const E_DATA_LIBRARY_SEARCH = 'data_library_search';
export const E_ADVANCED_SEARCH = 'advanced_search';
export const E_SIDEBAR_FAVOURITES = 'sidebar_favourites';
export const E_SIDEBAR_MENU = 'sidebar_menu';
export const E_MOBILE_MINIMIZED_DRAWER = 'mobile_minimized_drawer';

export const CHAT_CLASS_ASSISTANT = 'assistant_chat';
export const CHAT_CLASS_SMART_MEET = 'smart_meet_chat';
export const CHAT_CLASS_DATA_ANALYST = 'data_analyst_chat';
export const CHAT_CLASS_DEFAULT = 'chat';
export const CHAT_TYPE_ENTERPRISE = 'enterprise_chat';
export const CHAT_TYPE_WORLD_KNOWLEDGE = 'world_knowledge_chat';
export const CHAT_KNOWLEDGE_SOURCE_CHANGED = 'chat_knowledge_source_changed';
export const CHAT_TYPE_WORLD_KNOWLEDGE_WEB_SEARCH =
  'world_knowledge_web_search_chat';

export const TOOL_WEB_SEARCH = 'web_search';
export const TOOL_PRO_SEARCH = 'pro_search';
export const TOOL_COMPARE_MODELS = 'compare_models';
export const TOOL_IMAGE_GENERATION = 'image_generation';
export const TOOL_CANVAS = 'canvas';
export const TOOL_LIBRARY_RESOURCES = 'library_resources';
export const TOOL_ATTACHED_FILES = 'attached_files';
export const TOOL_ATTACHED_RESOURCES = 'attached_resources';
export const TOOL_STICK_TO_DOCUMENTS = 'stick_to_documents';
export const TOOL_REGENERATE_RESPONSE = 'regenerate_response';

// Page Header
export const PAGE_HEADER_TAB_CHANGED = 'page_header_tab_changed';

// Assistant Analytics Events
export const ASSISTANT_DISCARD_CHANGES = 'assistant_discard_changes_clicked';
export const ASSISTANT_STAY_ON_PAGE = 'assistant_stay_on_page_clicked';
export const ASSISTANT_CREATED = 'assistant_created';
export const ASSISTANT_UPDATED = 'assistant_updated';
export const ASSISTANT_SEARCH = 'assistant_search';
export const ASSISTANT_ADD_ACTION = 'assistant_add_action_clicked';
export const ASSISTANT_CREATION_MODAL_OPENED =
  'assistant_creation_modal_opened';
export const ASSISTANT_EDIT_ACTION = 'assistant_edit_button_clicked';
export const ASSISTANT_DELETE_ACTION = 'assistant_delete_button_clicked';
export const ASSISTANT_START_CHAT = 'assistant_start_chat_clicked';
export const ASSISTANT_SHARE_ASSISTANT = 'assistant_share_button_clicked';
export const ASSISTANT_MARK_FAVOURITE = 'assistant_mark_favourite';
export const ASSISTANT_CONNECTOR_CLICKED = 'assistant_connector_clicked';
export const ASSISTANT_MODEL_SELECTION = 'assistant_model_selection';
export const ASSISTANT_KNOWLEDGE_SOURCE_CHANGE =
  'assistant_knowledge_source_change';

// Smart Meet Analytics Events
export const SMART_MEET_PAGE_VIEWED = 'smart_meet_page_viewed';
export const SMART_MEET_RECORD_CLICKED = 'smart_meet_record_clicked';
export const SMART_MEET_IMPORT_UPLOAD_CLICKED =
  'smart_meet_import_upload_clicked';
export const SMART_MEET_IMPORT_FROM_WORKSPACE_CLICKED =
  'smart_meet_import_from_workspace_clicked';
export const SMART_MEET_RECORDING_PAUSED = 'smart_meet_recording_paused';
export const SMART_MEET_RECORDING_RESUMED = 'smart_meet_recording_resumed';
export const SMART_MEET_RECORDING_MINIMIZED = 'smart_meet_recording_minimized';
export const SMART_MEET_RECORDING_RENAMED = 'smart_meet_recording_renamed';
export const SMART_MEET_MEETING_OPENED = 'smart_meet_meeting_opened';
export const SMART_MEET_MEETING_DELETED = 'smart_meet_meeting_deleted';
export const SMART_MEET_MEETING_SHARED = 'smart_meet_meeting_shared';
export const SMART_MEET_MEETING_EXPORTED_PDF =
  'smart_meet_meeting_exported_pdf';
export const SMART_MEET_TAB_CHANGED = 'smart_meet_tab_changed';
export const SMART_MEET_SUMMARY_EDIT_CLICKED =
  'smart_meet_summary_edit_clicked';
export const SMART_MEET_SUMMARY_SAVED = 'smart_meet_summary_saved';
export const SMART_MEET_SUMMARY_REGENERATED = 'smart_meet_summary_regenerated';
export const SMART_MEET_SPEAKER_RENAME_SUBMITTED =
  'smart_meet_speaker_rename_submitted';
export const SMART_MEET_PROCESSING_RESUMED = 'smart_meet_processing_resumed';
export const SMART_MEET_PROCESSING_MEETING_DELETED =
  'smart_meet_processing_meeting_deleted';
export const SMART_MEET_ASK_EMPOWER_OPENED = 'smart_meet_ask_empower_opened';
export const SMART_MEET_ACTION_ITEM_CHECKED = 'smart_meet_action_item_checked';
export const SMART_MEET_ACTION_ITEM_UNCHECKED =
  'smart_meet_action_item_unchecked';
export const SMART_MEET_MEETING_ROW_CLICKED = 'smart_meet_meeting_row_clicked';
export const SMART_MEET_MEETING_NAME_EDITED = 'smart_meet_meeting_name_edited';
export const SMART_MEET_DRAFT_RECORDING_RESUMED =
  'smart_meet_draft_recording_resumed';
export const SMART_MEET_DRAFT_RECORDING_PLAYED =
  'smart_meet_draft_recording_played';
export const SMART_MEET_DRAFT_RECORDING_UPLOADED =
  'smart_meet_draft_recording_uploaded';
export const SMART_MEET_DRAFT_RECORDING_DELETED =
  'smart_meet_draft_recording_deleted';
export const SMART_MEET_MINIMIZED_RECORDING_STOPPED =
  'smart_meet_minimized_recording_stopped';
export const SMART_MEET_MINIMIZED_RECORDING_PAUSED =
  'smart_meet_minimized_recording_paused';
export const SMART_MEET_MINIMIZED_RECORDING_RESUMED =
  'smart_meet_minimized_recording_resumed';
export const SMART_MEET_MEETING_RECORDED = 'smart_meet_meeting_recorded';
export const SMART_MEET_MEETING_UPLOADED = 'smart_meet_meeting_uploaded';
export const SMART_MEET_SUMMARY_GENERATED = 'smart_meet_summary_generated';
export const SMART_MEET_NOTE_ADDED = 'smart_meet_note_added';
export const SMART_MEET_ASK_EMPOWER_QUERY_SENT =
  'smart_meet_ask_empower_query_sent';
export const SMART_MEET_GRID_ASK_EMPOWER = 'smart_meet_grid_ask_empower';
export const SMART_MEET_MEETING_DETAILS_ASK_EMPOWER =
  'smart_meet_meeting_details_ask_empower';
export const SMART_MEET_UPLOAD_SOURCE_WORKSPACE =
  'smart_meet_upload_source_workspace';

// Doc Analyst Analytics Events
export const DOC_ANALYST_TAB_CHANGED = 'doc_analyst_tab_changed';
export const DOC_ANALYST_NEW_ANALYSIS_CLICKED =
  'doc_analyst_new_analysis_clicked';
export const DOC_ANALYST_ANALYSIS_OPENED = 'doc_analyst_analysis_opened';
export const DOC_ANALYST_ANALYSIS_RUN = 'doc_analyst_analysis_run';
export const DOC_ANALYST_ANALYSIS_DELETED = 'doc_analyst_analysis_deleted';
export const DOC_ANALYST_ANALYSIS_EXPORTED = 'doc_analyst_analysis_exported';
export const DOC_ANALYST_DATASET_PICKER_OPENED =
  'doc_analyst_dataset_picker_opened';
export const DOC_ANALYST_DATASET_SELECTED = 'doc_analyst_dataset_selected';
export const DOC_ANALYST_DATASET_OPENED = 'doc_analyst_dataset_opened';
export const DOC_ANALYST_DATASET_CREATED = 'doc_analyst_dataset_created';
export const DOC_ANALYST_QUESTIONNAIRE_PICKER_OPENED =
  'doc_analyst_questionnaire_picker_opened';
export const DOC_ANALYST_QUESTIONNAIRE_SELECTED =
  'doc_analyst_questionnaire_selected';
export const DOC_ANALYST_QUESTIONNAIRE_OPENED =
  'doc_analyst_questionnaire_opened';
export const DOC_ANALYST_QUESTIONNAIRE_CREATED =
  'doc_analyst_questionnaire_created';
export const DOC_ANALYST_QUESTIONNAIRE_UPDATED =
  'doc_analyst_questionnaire_updated';
export const DOC_ANALYST_QUESTIONNAIRE_CLONED =
  'doc_analyst_questionnaire_cloned';
export const DOC_ANALYST_DATASET_DELETED = 'doc_analyst_dataset_deleted';
export const DOC_ANALYST_QUESTIONNAIRE_DELETED =
  'doc_analyst_questionnaire_deleted';
export const DOC_ANALYST_QUESTIONNAIRE_SEND_MODAL_OPENED =
  'doc_analyst_questionnaire_send_modal_opened';
export const DOC_ANALYST_QUESTIONNAIRE_SENT = 'doc_analyst_questionnaire_sent';
export const DOC_ANALYST_ANALYSIS_FILTER_CHANGED =
  'doc_analyst_analysis_filter_changed';
export const DOC_ANALYST_ANALYSIS_SEARCHED = 'doc_analyst_analysis_searched';
export const DOC_ANALYST_SCORING_ANALYSIS_RUN =
  'doc_analyst_scoring_analysis_run';
export const DOC_ANALYST_SIMPLE_ANALYSIS_RUN =
  'doc_analyst_scoring_analysis_run';

// Data Analyst Analytics Events
export const DATA_ANALYST_NEW_ANALYSIS_CLICKED =
  'data_analyst_new_analysis_clicked';
export const DATA_ANALYST_CHAT_OPENED = 'data_analyst_chat_opened';
export const DATA_ANALYST_CHAT_RENAMED = 'data_analyst_chat_renamed';
export const DATA_ANALYST_CHAT_DELETED = 'data_analyst_chat_deleted';
export const DATA_ANALYST_PAGE_CHANGED = 'data_analyst_page_changed';
